import React from 'react'
import classes from '../../Sidebar.module.scss'
import {
  ModalMenu
} from 'components/Modal'
import {
  MenuItem as ModalMenuItem
} from 'components/Menu'
import KanBoIcon from 'components/KanBoIcon'

export class MenuItemGroup extends React.Component {
  renderMenu () {
    const { menu } = this.props

    return !!menu && (
      <ModalMenu>
        <span
          className={classes.menuIcon}
        >
          <KanBoIcon name='kanbo-16-options' />
        </span>
        {Array.isArray(menu)
          ? menu.map((menuItem, index) => {
            if (React.isValidElement(menuItem)) {
              return menuItem
            }

            const { title, ...menuItemProps } = menuItem

            return (
              <ModalMenuItem
                {...menuItemProps}
                key={index}
              >
                {title}
              </ModalMenuItem>
            )
          })
          : menu
        }
      </ModalMenu>
    )
  }

  render () {
    const {
      children,
      title,
      actions,
    } = this.props

    return (
      <React.Fragment>
        <div className={classes.menuItemGroupHeader}>
          <span className={classes.menuItemTitle}>
            {title}
          </span>
          {actions}
          {this.renderMenu()}
        </div>
        {children}
      </React.Fragment>
    )
  }
}

export default MenuItemGroup
